(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["volt-drink-decide"] && !Shopify.designMode) return;
  try {
    (() => {
    const widget = document.querySelector('[data-volt-dd]');
    if (!widget) return;
    const key = 'volt-drink-decide-dismissed-v1';
    try { if (sessionStorage.getItem(key) === '1') return; } catch {}
    const toggle = widget.querySelector('.volt-dd__toggle');
    const panel = widget.querySelector('.volt-dd__panel');
    let pinned = false;
    const setOpen = (open) => {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    };
    widget.hidden = false;
    widget.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') setOpen(true);
    });
    widget.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse' && !pinned && !widget.contains(document.activeElement)) setOpen(false);
    });
    toggle.addEventListener('focus', () => {
      if (toggle.matches(':focus-visible')) setOpen(true);
    });
    toggle.addEventListener('click', () => {
      pinned = !pinned;
      setOpen(pinned);
    });
    widget.addEventListener('focusout', (event) => {
      if (!widget.contains(event.relatedTarget)) { pinned = false; setOpen(false); }
    });
    document.addEventListener('pointerdown', (event) => {
      if (!widget.contains(event.target)) { pinned = false; setOpen(false); }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { pinned = false; setOpen(false); }
    });
    widget.querySelector('.volt-dd__close').addEventListener('click', () => {
      widget.hidden = true;
      try { sessionStorage.setItem(key, '1'); } catch {}
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
